// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1vTzz","modalForm":"UpgradeEpcsModal_modalForm__3c4JM","modalFooter":"UpgradeEpcsModal_modalFooter__2lS-B"};